import WebRotData from './WebRotData';

export default WebRotData;
